export default "<div style=\"background-color:white\">\n\n\t<app-translation-list short=\"false\"></app-translation-list>\n</div>"